import _ from 'lodash';
import { createSelector } from 'reselect';
import { JOB_NAMES } from 'common/services/jobs-suites.service';
import { calculatePercentage } from 'common/utils/utils';
import { isProcessingReposSelector } from './ui-state';

const MIN_DEFAULT_PERCENTAGE = 3;

const countJobsByState = (jobs, jobState) =>
  jobs.filter(({ state } = {}) => state === jobState).length;
const resolvePercentageBoundaries = percentage =>
  Math.max(MIN_DEFAULT_PERCENTAGE, Math.min(percentage, 100));

const getJobsPercentage = jobs => {
  const totalJobs = jobs.length;
  const startedJobs = countJobsByState(jobs, 'started');
  const processedJobs =
    countJobsByState(jobs, 'completed') + countJobsByState(jobs, 'failed');
  return calculatePercentage(processedJobs + startedJobs / 2, totalJobs);
};

const getJobs = state => state.jobs;

const getProcessingPercentageFromOnboardingJob = job => {
  const onboardingJobs = job.flatMap(({ batch_jobs = {} }) => {
    return Object.values(batch_jobs).filter(
      ({ component_type }) => component_type === 'main_flows'
    );
  });
  return getJobsPercentage(onboardingJobs);
};

export const isSyncContributorsJobFinishedSelector = createSelector(
  getJobs,
  jobs =>
    ['completed', 'failed'].includes(
      _.get(jobs[JOB_NAMES.TEAM_SYNC_CONTRIBUTORS], 'state')
    )
);

export const calcualteRepoProcessingPercentage = (jobs, isProcessingRepos) => {
  if (isProcessingRepos) {
    return '';
  }
  const processingJobs = jobs[JOB_NAMES.ONBOARDING] || [];
  if (!processingJobs.length) {
    return '0%';
  }
  const percentage = getProcessingPercentageFromOnboardingJob(processingJobs);
  return isNaN(percentage) ? '' : `${resolvePercentageBoundaries(percentage)}%`;
};

export const reposProcessPercentageSelector = createSelector(
  [getJobs, isProcessingReposSelector],
  (jobs, isProcessingRepos) => {
    return calcualteRepoProcessingPercentage(jobs, isProcessingRepos);
  }
);
